import { render, staticRenderFns } from "./addEdit.vue?vue&type=template&id=972b6e9c&scoped=true"
import script from "./addEdit.vue?vue&type=script&lang=js"
export * from "./addEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972b6e9c",
  null
  
)

export default component.exports